import { createGraph, barGraphFormatter } from 'graph'

const graphModule = createGraph({
  name: 'graphVehicleEmissions',
  api: 'dashboard/VehicleEmissions',
  formatter: (state, action) => {
    // Add graphName to payload for formatter
    if (action && action.payload) {
      action = { ...action, payload: { ...action.payload, graphName: 'graphVehicleEmissions' } }
    }
    return barGraphFormatter(state, action)
  },
})

export const actions = graphModule.actions
export const constants = graphModule.constants
export const effects = graphModule.effects
export const reducer = graphModule.reducer

export const useGraphFetch = graphModule.hooks.useGraphFetch
